import React, { Component } from "react"
import PropTypes from "prop-types"
import ReactSlider from "react-slick"
import { withRadium, DetectCompact } from "higher-order-components"
import { injectGlobal } from "styled-components"
import globalStyles from "./slick.css"

if (process.env.BABEL_ENV && process.env.BABEL_ENV === "dingo") {
  injectGlobal`
    ${globalStyles}
  `
} else {
  require("./slick.css")
}
class Slider extends Component {
  render() {
    let settings = {}
    if (!this.props.settings) {
      settings = {
        arrows: !this.props.compact,
        centerMode: false,
        mobileFirst: true,
        infinite: false,
        variableWidth: true,
        slidesToShow: 9,
        slidesToScroll: 5,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 604,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 906,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1208,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1510,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1812,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 2114,
            settings: {
              slidesToShow: 6,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 2416,
            settings: {
              slidesToShow: 7,
              slidesToScroll: 4
            }
          },
          {
            breakpoint: 2718,
            settings: {
              slidesToShow: 8,
              slidesToScroll: 5
            }
          }
        ]
      }
    } else {
      settings = this.props.settings
    }
    return <ReactSlider {...settings}>{this.props.children}</ReactSlider>
  }
}

Slider.propTypes = {
  children: PropTypes.array,
  compact: PropTypes.bool,
  settings: PropTypes.object
}

export default withRadium(DetectCompact())(Slider)



// WEBPACK FOOTER //
// ./src/containers/slider/index.jsx